import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant from '../../Constant.js'
import axios from 'axios'

class FaqModuleAdd extends React.Component {
  state = {
    question_en: '',
    question_ar: '',
    answer_en: '',
    answer_ar: '',
    faqId: '',
    isData: false,
    Edit: false,
  }

  componentDidMount() {
    if (this.props.match.params.id) {
      this.getFaqData(this.props.match.params.id)
    }
  }

  getFaqData = async (id) => {
    await axios
      .get(Constant.getAPI() + `/faq/details/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(async (res) => {
        if (res?.data?.success) {
          this.setState({
            ...res?.data?.data,
          })
          this.setState({ Edit: true })
        }
      })
  }

  handleChange = async (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  addFaq = () => {
    let data = {
      question_en: this.state.question_en,
      question_ar: this.state.question_ar,
      answer_en: this.state.answer_en,
      answer_ar: this.state.answer_ar,
    }
    this.setState({ isSaving: true })

    this.setState({ isData: true })
    if (this.props?.match?.params?.id) {
      data.id = this.props?.match?.params?.id
      axios
        .put(Constant.getAPI() + '/faq/update-faq', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'FAQ Updated Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/faq-list`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      axios
        .post(Constant.getAPI() + '/faq/create-faq', data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        })
        .then((res) => {
          this.setState({ isData: false })
          if (res.status) {
            Swal.fire({
              title: 'FAQ Added Successfully!',
              icon: 'success',
              text: '',
              type: 'success',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
          window.location.href = `#/faq-list`
        })
        .catch((err) => {
          this.setState({ isData: false })
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    }
  }

  onSaveData = () => {
    this.setState({ isSaving: true })
    this.addFaq()
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>FAQ {this.props.match.params.id ? 'Edit' : 'Add'} </h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to={`/faq-lists`}> FAQ List</Link>
                    </li>
                    <li className="breadcrumb-item active">FAQ {this.props.match.params.id ? 'Edit' : 'Add'} </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane active"
                        id={'flight_class_add_' + this.state.language_id}
                        role="tabpanel"
                        aria-labelledby=""
                      >
                        <div className="">
                          <div className="card-body">
                            <div className="row">
                              <div className="col-md-12">
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">Question: English</label>
                                  <div className="col-sm-9">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="question_en"
                                      id="question_en"
                                      placeholder={`Question: English`}
                                      onChange={this.handleChange}
                                      value={this.state.question_en}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">Question: Arabic</label>
                                  <div className="col-sm-9">
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="question_ar"
                                      id="question_ar"
                                      placeholder={`Question: Arabic`}
                                      onChange={this.handleChange}
                                      value={this.state.question_ar}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div
                                className="col-md-12"
                                style={{ borderTop: '2px solid #eee', marginBottom: 20 }}
                              ></div>
                              <div className="col-md-12">
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">Answer: English</label>
                                  <div className="col-sm-9">
                                    <textarea
                                      rows={4}
                                      className="form-control"
                                      name="answer_en"
                                      id="answer_en"
                                      placeholder="Answer: English"
                                      value={this.state.answer_en}
                                      onChange={this.handleChange}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-12">
                                <div className="form-group row">
                                  <label className="col-sm-3 col-form-label">Answer: Arabic</label>
                                  <div className="col-sm-9">
                                    <textarea
                                      rows={4}
                                      className="form-control"
                                      name="answer_ar"
                                      id="answer_ar"
                                      placeholder="Answer: Arabic"
                                      value={this.state.answer_ar}
                                      onChange={this.handleChange}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="card-footer">
                              <div className="row">
                                <div className="text-right col-6 offset-6">
                                  <Link
                                    to={`/faq-list`}
                                    className="btn btn-outline-secondary m-2 "
                                  >
                                    <i className="icofont icofont-rounded-double-left"></i>
                                    Back
                                  </Link>
                                  {this.state.isData ? (
                                    <button
                                      className="btn btn-grd-disabled mr-2"
                                      disabled
                                    >
                                      Saving...!
                                    </button>
                                  ) : (
                                    <button
                                      onClick={this.onSaveData}
                                      className="btn hor-grd btn-grd-inverse offset-1"
                                    >
                                      <i className="ti-save"></i>Save
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default FaqModuleAdd
